import { isSameDay } from '@/modules/shared/utils/isSameDay';
import type {
  DeliveryGroup,
  PickupOption,
  ShippingOption
} from '@/modules/shippingMethod/domain/ShippingMethod';
import type { GeneralDeliveryOptionDto } from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';

export const findScheduledOption = (
  date: Date,
  scheduledOptions: DeliveryGroup['scheduledOptions']
): GeneralDeliveryOptionDto | undefined => {
  const options = scheduledOptions && scheduledOptions[0].options;
  return options?.find((opt) =>
    isSameDay(new Date(opt.deliveryDateFrom), date)
  );
};

export const getNearestDate = (
  shippingOptions?: ShippingOption[],
  pickupOptions?: PickupOption[]
): string => {
  const allDates: string[] = [];

  shippingOptions?.forEach((option) => {
    if (option.deliveryDateFrom) {
      allDates.push(option.deliveryDateFrom);
    }
  });

  pickupOptions?.forEach((option) => {
    if (option.deliveryDateFrom) {
      allDates.push(option.deliveryDateFrom);
    }
  });

  if (allDates.length === 0) return '';

  const sortedDates = allDates.sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime()
  );

  return sortedDates[0]?.split('T')[0] ?? '';
};

export const getNearestDateByType = (
  options?: ShippingOption[] | PickupOption[],
  subType?: string
): string => {
  if (!options || !subType) return '';

  const filteredDates = options
    .filter((opt) => opt.shippingSubType === subType && opt.deliveryDateFrom)
    .map((opt) => opt.deliveryDateFrom as string)
    .sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

  return filteredDates[0]?.split('T')[0] ?? '';
};

export const getShippingPrice = (
  shippingOptions?: ShippingOption[]
): number => {
  const selectedOption = shippingOptions?.find((opt) => opt.selected);
  if (!selectedOption?.price) return 0;

  return parseInt(selectedOption.price.replace(/\D/g, ''), 10) || 0;
};
